import Cookies from "js-cookie";

// @ts-ignore
import router from "@/router";
// @ts-ignore
import store from "@/store";

// const storageKeyPrefix = import.meta.env.VITE_APP_STORAGE_KEY_PREFIX
const storageKeyPrefix = "jg";
export const TokenKey = `${storageKeyPrefix}-Token`;

export const setToken = (token: string, expires: number) =>
  Cookies.set(TokenKey, token, { expires: expires || 1 }); // { expires: 1 }
export const getToken = () => Cookies.get(TokenKey);
export const removeToken = () => {
  Cookies.remove(TokenKey);
};

// logout
export const logoutCleanup = () => {
  removeToken();
  router.navigate("/login", {
    replace: true
  });
  //   store.dispatch(cleanupUser())
  //   store.dispatch(cleanupMenu())
};
